import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { AuthenticationSendPasswordResetCodeUseCaseInterface } from 'domain/usecases';

export class RemoteAuthenticationSendPasswordResetCode
  implements AuthenticationSendPasswordResetCodeUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: AuthenticationSendPasswordResetCodeUseCaseInterface.Params,
  ): Promise<AuthenticationSendPasswordResetCodeUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      body: params,
      method: 'post',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
